import Api from "@/service/api";
import { Captcha, ThirdLogin, VerifyType } from "./enum";


// 获取邮箱验证码
export async function smsCode(options?: { [key: string]: any }) {
  return Api.request({
    url: "/user/send_email_for_reset_password",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 获取邮箱验证码
export async function reset_password(options?: { [key: string]: any }) {
  return Api.request({
    url: "/user/send_email_for_reset_password",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 注册
export async function register(options?: { [key: string]: any }) {
  return Api.request({
    url: "/user/register",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 登录
export async function login(
  options?: { [key: string]: any },
) {
  return Api.request({
    url: "/user/login",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 获取deviceId
export async function getDeviceId() {
  return Api.request({
    url: "/config",
    method: "GET",
  });
}

// 退出登录
export async function logout() {
  return Api.request({
    url: "/user/logout",
    method: "POST",
  });
}

// 重置密码
export async function resetPassword(options?: { [key: string]: any }) {
  return Api.request({
    url: "/member/reset-pass",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 获取滑块验证码
export async function getCaptcha(uuid: string, verificationEnums?: Captcha) {
  return Api.request({
    url: `/member/getCaptcha/${verificationEnums}`,
    method: "POST",
    headers: { uuid },
  });
}

// 验证码预校验
export async function preCheck(
  uuid: string,
  verificationEnums: Captcha,
  xPos: number,
) {
  return Api.request({
    url: `/member/preCheck/${verificationEnums}`,
    method: "POST",
    headers: { uuid },
    params: { xPos },
  });
}

// 记录用户cookie信息
export async function cookieRecord(
  deviceId: string,
  options?: { [key: string]: any },
) {
  return Api.request({
    url: `/member/cookieRecord`,
    method: "POST",
    headers: { deviceId },
    data: {
      ...(options || {}),
    },
  });
}

// 判断用户是否已注册
export async function queryUserSigned(params: { email: string }) {
  return Api.request({
    url: "/member/queryUserSigned",
    method: "POST",
    params,
  });
}

// google登录
export async function googleLogin(params: { idToken: string }) {
  return Api.request({
    url: "/google_login",
    method: "POST",
    data: params,
  });
}

// facebook登录
export async function facebookLogin(token: string) {
  return Api.request({
    url: "/member/auth/google/facebookTokenLogin",
    method: "GET",
    params: {
      token,
    },
  });
}

// 检验邮箱是否注册
export async function verifyEmailThirdLogin(email: string, token: string | undefined, loginPlatform: ThirdLogin) {
  return Api.request({
    url: "/member/checkEmailSignup",
    method: "POST",
    params: {
      email,
      token,
      loginPlatform,
    },
  });
}

// 绑定邮箱
export async function thirdUserBindEmail(options?: { [key: string]: any }) {
  return Api.request({
    url: "/member/thirdUserBindEmail",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 获取用户信息
export async function getUserInfo() {
  return Api.request({
    url: "/user/info",
    method: "GET",
  });
}

// 获取积分信息
export async function getUserWallet() {
  return Api.request({
    url: "/user/wallet",
    method: "GET",
  });
}

// 持仓情况
export async function getUserSummary() {
  return Api.request({
    url: "/askpaul/portfolio/summary",
    method: "GET",
  });
}

// 获取签到记录
export async function getUserCheckIn() {
  return Api.request({
    url: "/check_in/record",
    method: "GET",
  });
}

// 签到
export async function userCheckIn() {
  return Api.request({
    url: "/check_in",
    method: "POST",
  });
}

// 获取用户分享信息
export async function getUserShareInfo() {
  return Api.request({
    url: "/tasks",
    method: "GET",
  });
}

// 获取my blance列表
export async function getBalanceList(options?: { [key: string]: any }) {
  return Api.request({
    url: "/wallet_bills/group_by_month/my",
    method: "GET",
    params: { ...options }
  });
}


// 获取invite Info
export async function getInviteInfo() {
  return Api.request({
    url: "/invite_code/info",
    method: "GET",
  });
}

// 用户填写邀请码
export async function inviteCode(params: { code: string }) {
  return Api.request({
    url: "/invite_code/fill_in",
    method: "POST",
    data: params,
  });
}